import React, { ChangeEvent } from "react";
import CField from "$forms/CField";
import ActivitiesSelect from "$forms/ActivitiesSelect";
import { useUserFormContext } from "../context/UserFormContext";
import {
  emailRegexp,
  nameRegexp,
  NAME_ERROR_MSG,
  normalizeName,
} from "$utils/utils";
import { useStyles } from "./styles";

type Props = {
  validateEmailExists: () => Promise<void>;
};

export const UserFormBasicInfo: React.FC<Props> = ({ validateEmailExists }) => {
  const { form, activitiesOptions, isCoordinator } = useUserFormContext();
  const {
    control,
    setValue,
    trigger,
    formState: { errors },
  } = form;
  const classes = useStyles();

  return (
    <>
      {activitiesOptions?.length > 0 && (
        <div className={classes.fieldsRow} style={{ marginTop: 0 }}>
          <CField
            control={control}
            label="Activité"
            name="activity"
            rules={{
              required: "Veuillez sélectionner une activité",
            }}
            error={errors.activity}
          >
            {(props: any) => (
              <ActivitiesSelect
                activitiesOptions={activitiesOptions}
                value={props.value}
                onChange={props.onChange}
                required
              />
            )}
          </CField>
        </div>
      )}
      <div
        className={classes.fieldsRow}
        style={{ ...(activitiesOptions?.length > 0 ? {} : { marginTop: 0 }) }}
      >
        <CField
          label="Nom"
          control={control}
          name="lastname"
          required
          error={errors.lastname}
          placeholder="Tapez le nom"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setValue("lastname", normalizeName(e.target.value));
            if (e.target.value) {
              trigger("lastname");
            }
          }}
          rules={{
            pattern: {
              value: nameRegexp,
              message: NAME_ERROR_MSG,
            },
          }}
        />
      </div>
      <div className={classes.fieldsRow}>
        <CField
          label="Prénom"
          control={control}
          name="firstname"
          required
          error={errors.firstname}
          placeholder="Tapez le prénom"
          rules={{
            pattern: {
              value: /^[\\pM\\pLa-zA-ZÀ-ú ,.'-]+$/,
              message: "Veuillez saisir un prénom valide",
            },
          }}
        />
      </div>
      <div className={classes.fieldsRow}>
        <CField
          label="E-mail"
          control={control}
          name="email"
          required
          error={errors.email}
          placeholder="Tapez l'e-mail"
          rules={{
            pattern: {
              value: emailRegexp,
              message: "Veuillez saisir un e-mail valide",
            },
            validate: {
              emailExists: validateEmailExists,
            },
          }}
        />
      </div>
      {!isCoordinator && (
        <div className={classes.fieldsRow}>
          <CField
            label="Fonction"
            control={control}
            name="job"
            error={errors.job}
            placeholder="Tapez la fonction"
          />
        </div>
      )}
    </>
  );
};
